import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ConvivaApi } from "src/app/conviva-api";
import { DefaultResponse } from "../../../shared/models/DefaultResponse";
import { FiltroPadraoPec } from "../../../pages/pec/models/filtro-padrao-pec";

@Injectable({
  providedIn: 'root'
})
export class GraficoService {

  private api = ConvivaApi;

  constructor(
    private http: HttpClient) { }

  public GetDataGraphOcorrenciasPendentes(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphOcorrenciasPendentes}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataGraphOcorrenciasConcluidas(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphOcorrenciasConcluidas}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataGraphAcoesPreventivas(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphAcoesPreventivas}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataGraphAcoesAcolhimentoPOC(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphAcoesAcolhimentoPOC}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }
  public GetDataGraphAcoesPreventivasPOC(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetDataGraphAcoesPreventivasPOC}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }


  public GetDataGraphAcolhimentoPsicologo(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphAcolhimentoPsicologo}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataGraphPreencheramPMCE(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphPreencheramPMCE}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataGraphNaoPreencheramPMCE(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphNaoPreencheramPMCE}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetPreencheramPlanoContingencia(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphPreencheramPlanoContingencia}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetNaoPreencheramPlanoContingencia(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphNaoPreencheramPlanoContingencia}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataGraphEncaminhamentosAberto(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphEncaminhamentosAberto}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataGraphAgendamentoRealizado(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphAgendamentoRealizado}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataGraphAcolhimentoConcluido(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphAcolhimentoConcluido}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataGraphAcolhimentoAtraso(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphAcolhimentoAtraso}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataGraphPrevencao(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphPrevencao}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetDataValidadosNaoValidados(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetDataValidadosNaoValidados}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public GetGraphDiasSemOcorrencias(parametros: FiltroPadraoPec): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Grafico.GetGraphDiasSemOcorrencias}`, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

}
